// extracted by mini-css-extract-plugin
export default {"page-title":"styles_page-title__jSs3W","skill-search":"styles_skill-search__7IATm","layout":"styles_layout__yQuUG","container":"styles_container__iNf0x"};